import cx from 'classnames';
import React, { forwardRef } from 'react';

import styles from './styles.css';
import Box, { BoxProps } from '../Box';

export interface IconButtonProps extends BoxProps {
  icon: React.ReactElement;
}

const IconButton = forwardRef<HTMLElement, IconButtonProps>(
  ({ element = 'button', icon, className, type, ...rest }, ref) => {
    const classNames = cx(styles['icon-button'], className);
    const isButton = element === 'button';

    return (
      <Box
        ref={ref}
        element={element}
        className={classNames}
        type={type || (isButton ? 'button' : undefined)}
        {...rest}
      >
        {icon}
      </Box>
    );
  },
);

export default IconButton as React.ComponentType<IconButtonProps>;
